import classNames from "classnames";
import { FC, ReactNode } from "react";

interface Props {
  step: { title: string; icon: ReactNode };
  isDone: boolean;
  isActive: boolean;
}

const ReleaseStep: FC<Props> = ({ isActive, isDone, step }) => {
  return (
    <div className={classNames("flex w-full items-center gap-2  grow")}>
      <div className="h-5    w-fds-22 min-w-fds-22 md:h-8 md:w-9 md:min-w-9 relative text-fds-brand">
        <div
          className={classNames(
            "absolute top-0 left-0 z-10",
            isDone ? "text-fds-brand" : "text-fds-icon-secondary"
          )}
        >
          {step.icon}
        </div>
        <div
          className={classNames(
            "w-4     h-4     md:w-6 md:h-6 rounded-full absolute bottom-0 right-0",
            isDone ? "bg-fds-brand-light" : "bg-fds-secondary"
          )}
        />
      </div>
      <p
        className={classNames(
          "title-sm md:title-md-medium",
          isActive ? "text-fds-brand" : "text-fds-primary"
        )}
      >
        {step.title}
      </p>
    </div>
  );
};

export default ReleaseStep;
